module.exports = __webpack_public_path__ + "img/search active.e0c7fc0f.svg";